<h1 mat-dialog-title>Recommend Job</h1>
<button mat-dialog-close class="close-btn" aria-label="Close"><mat-icon>close</mat-icon></button>
<div mat-dialog-content class="dialog-content">
    <div class="recommend-text">
        <p data-qa-id="rq-recommend-job-text">
            Are you sure you want to recommend this job to the selected candidate(s)? They will be able to view it on the My Jobs page in Aya Talent Marketplace.
        </p>
    </div>
    <div class="candidate-names">
        <ul>
            @for(candidate of data.candidateNames(); track $index) {
                <li
                    class="candidate-name"
                    data-qa-id="rq-recommend-job-candidate-name"
                >
                    {{candidate}}
                </li>
            }
        </ul>
    </div>
</div>
<div mat-dialog-actions>
    <button
        mat-flat-button
        (click)="sendRecommendations()"
        color="primary"
        data-qa-id="rq-recommend-job-action-send-btn"
        [disabled]="isRecommending()"
    >
        @if (isRecommending()) {
            <mat-icon data-qa-id="button-spinner">
                <mat-spinner [diameter]="spinnerSize()"></mat-spinner>
            </mat-icon>
        } @else {
            YES, SEND JOB
        }
    </button>
    <button
        mat-flat-button
        (click)="close()"
        [disabled]="isRecommending()"
        class="tertiary"
        data-qa-id="rq-recommend-job-action-cancel-btn"
        >CANCEL</button
    >
</div>
